import {
  CreateEventBase,
  TimelineAdapter,
  TimelineEventData,
  TimelineEventProducer
} from '@fnd/timeline'
import AssistantEventBus from './AssistantEventBus'
import AssistantChatAdapter from './AssistantChatAdapter'
import {AppConfig} from '../../../../AppConfig'
import AssistantActionManager from './AssistantActionManager'
import AssistantMessageEvent from './AssistantMessageEvent'
import {SessionItemData} from '../sessions/Sessions'
import kc from 'web-common/services/auth'

const AI_ASSISTANT_ID = AppConfig.ws.ai_assistant_id

export class AssistantEventProducer extends TimelineEventProducer {
  eventBus = AssistantEventBus

  private chatAdapter = new AssistantChatAdapter(
    AssistantMessageEvent,
    this.eventBus,
    this,
    this.session.id,
    'CUSTOMER',
    '',
    ''
  )

  protected dataSourceServices: TimelineAdapter<unknown>[] = [this.chatAdapter]

  constructor(
    public session: SessionItemData,
    public actionManager: AssistantActionManager
  ) {
    super()
  }

  changeSession(session: SessionItemData) {
    this.session = session
    this.evaluateInitialLoading(this.getHistory())
  }

  async createEvent(
    event: CreateEventBase<any>
  ): Promise<TimelineEventData<any>> {
    await kc.instance.updateToken(0)
    let data!: TimelineEventData<any>

    // Create chat event
    if (event.adapterId === AssistantChatAdapter.id) {
      data = await this.chatAdapter.sendMessage({
        text: event.message ?? '',
        metadata: event.data?.metadata,
        assignmentId: this.session.id,
        recipientId: AI_ASSISTANT_ID
      })
    }

    this.actionManager.disableChat()
    this.actionManager.removeChatSuggestions()
    this.actionManager.addThinkingIndicator()

    this.update([data])
    return Promise.resolve(data)
  }

  protected evaluateInitialLoading(acc: TimelineEventData<unknown>[]): void {
    if (this.getHistory().length === 0) {
      this.actionManager.addChatSuggestions()
    }
  }

  async reCreateEvent(eventId: string): Promise<boolean> {
    await kc.instance.updateToken(0)
    let data!: TimelineEventData<any>
    const event = this.getHistory().find((e) => e._id === eventId)

    if (!event) {
      return false
    }

    if (event.adapterId === AssistantChatAdapter.id) {
      this.actionManager.addThinkingIndicator()

      const props = event.props as {
        message?: string
        metadata?: Record<string, any>
      }

      const message = {
        text: props.message ?? '',
        assignmentId: this.session.id,
        recipientId: AI_ASSISTANT_ID,
        ...(props.metadata && {metadata: props.metadata})
      }

      data = await this.chatAdapter.sendMessage(message)

      this.remove(event._id)
      this.update([data])
      return true
    }

    return false
  }

  hasDemandId(): boolean {
    return this.session.demandId ? true : false
  }

  setDemandId(demandId: string) {
    this.session.demandId = demandId
  }
}
